export default "__VITE_ASSET__5nfPiiGi__"